// extracted by mini-css-extract-plugin
export var container = "_f4-0";
export var infoIcon = "_f4-2";
export var titleRowCol = "_f4-1";